module.exports = __webpack_public_path__ + "static/media/rest4.5f3fef71.webp";